// components/AvatarCell.jsx
import styles from "../../../../style/cssModules/table/TableComponent.module.css";

const AvatarCell = ({ data }) => {
  const getInitials = () => {
    if (!data) return "";

    const firstName = data.firstName || "";
    const lastName = data.lastName || "";

    let initials = firstName ? firstName[0].toUpperCase() : "";

    if (lastName) {
      initials += lastName[0].toUpperCase();
    } else if (firstName.includes(" ")) {
      const names = firstName.split(" ");
      if (names.length > 1) {
        initials =
          names[0][0].toUpperCase() + names[names.length - 1][0].toUpperCase();
      }
    }

    return initials || "N/A";
  };

  const fullName =
    data?.firstName || data?.lastName
      ? `${data?.firstName || ""} ${data?.lastName || ""}`.trim()
      : "N/A";

  const initials = getInitials();

  return (
    <div className={styles.colImageSection}>
      {data?.image ? (
        <div className={styles.colImageWrapper}>
          <img
            src={data.image}
            alt={fullName}
            className={styles.productImage}
          />
        </div>
      ) : (
        <div className={`${styles.colImageWrapper} ${styles.initialsAvatar}`}>
          {initials}
        </div>
      )}
      <div className={styles.colAdminDetailsContainer}>
        <span className={styles.adminName}>{fullName}</span>
        <span className={styles.adminEmail}>{data?.email || "N/A"}</span>
      </div>
    </div>
  );
};

export default AvatarCell;
